module.exports = __webpack_public_path__ + "img/10.434ae4e1.png";